import React from "react";

export default function PricingLiquid({ onContactClick }) {
  return (
    <section className="section-liquid">
      <div className="container-liquid">
        <div style={{ textAlign: "center", marginBottom: "60px" }}>
          <span className="subheading-liquid">Pricing</span>
          <h2
            className="heading-liquid"
            style={{
              fontSize: "clamp(2rem, 4vw, 3rem)",
              marginTop: "16px",
              marginBottom: "24px",
            }}
          >
            Reach Out for{" "}
            <span
              style={{
                background: "var(--gradient-primary)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                color: "#007AFF", // Fallback color if gradient fails
              }}
            >
              Pricing Details.
            </span>
          </h2>
          <p
            className="text-liquid"
            style={{
              fontSize: "1.2rem",
              maxWidth: "600px",
              margin: "0 auto",
            }}
          >
            We offer customized pricing solutions tailored to your specific
            needs and requirements.
          </p>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            className="glass liquid-float"
            style={{
              padding: "60px 40px",
              textAlign: "center",
              maxWidth: "500px",
              width: "100%",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* Decorative background */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "var(--gradient-ios-blue)",
                opacity: 0.05,
                borderRadius: "20px",
              }}
            ></div>

            <div style={{ position: "relative", zIndex: 1 }}>
              <div
                style={{
                  fontSize: "4rem",
                  marginBottom: "24px",
                  filter: "drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2))",
                }}
              >
                💰
              </div>

              <h3
                className="heading-glass"
                style={{
                  fontSize: "1.75rem",
                  marginBottom: "20px",
                }}
              >
                Custom Pricing
              </h3>

              <p
                className="text-glass"
                style={{
                  fontSize: "1.1rem",
                  marginBottom: "32px",
                  lineHeight: "1.6",
                }}
              >
                We offer customized pricing solutions tailored to your specific
                needs. Contact us today to discuss the perfect plan for your
                business.
              </p>

              <div
                className="glass-tertiary"
                style={{
                  padding: "20px",
                  marginBottom: "32px",
                }}
              >
                <div style={{ marginBottom: "16px" }}>
                  <span
                    className="text-glass"
                    style={{
                      fontSize: "0.9rem",
                    }}
                  >
                    ✓ Custom website design
                  </span>
                </div>
                <div style={{ marginBottom: "16px" }}>
                  <span
                    className="text-glass"
                    style={{
                      fontSize: "0.9rem",
                    }}
                  >
                    ✓ Domain & hosting included
                  </span>
                </div>
                <div style={{ marginBottom: "16px" }}>
                  <span
                    className="text-glass"
                    style={{
                      fontSize: "0.9rem",
                    }}
                  >
                    ✓ SSL certificate
                  </span>
                </div>
                <div>
                  <span
                    className="text-glass"
                    style={{
                      fontSize: "0.9rem",
                    }}
                  >
                    ✓ Technical support
                  </span>
                </div>
              </div>

              <button
                className="glass-button glass-button-primary glow"
                onClick={onContactClick}
                style={{
                  fontSize: "1.1rem",
                  padding: "16px 32px",
                  width: "100%",
                }}
              >
                Get Custom Quote
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
